export default __webpack_public_path__ + "static/21-b7948acc31205cc1bc2b241f31f4f32e.png";